import { route } from "./route";

export type DashboardModule = {
  key: string;
  icon: string;
  href: string;
  permission: string;
  secondaryHref?: string;
};

// Process modules (casting, cutting, turning, vmc, buffing, platting) used to be
// listed here as static entries. They're now generated at runtime from the
// process_definitions master table by DailyUsageModules — see
// PROCESS_ICON_BY_SLUG / CUTTING_LEGACY_OVERRIDE there. Adding a 7th process
// needs zero changes here or in App.tsx routes for the process itself.
export const dailyModules: DashboardModule[] = [
  { key: "accountManagement", icon: "💰", href: route.accountTypes, secondaryHref: route.accounts, permission: "account-types.menu" },
];

// Fallback/known icons for dynamically-generated process tiles, keyed by
// process_definitions.slug. Cosmetic only — an unknown future slug falls
// back to PROCESS_ICON_DEFAULT rather than needing a backend schema change.
export const PROCESS_ICON_BY_SLUG: Record<string, string> = {
  casting: "🔩",
  cutting: "⚙️",
  turning: "🔧",
  vmc: "🛠️",
  buffing: "✨",
  platting: "🧪",
};
export const PROCESS_ICON_DEFAULT = "📦";

export const stockModules: DashboardModule[] = [
  { key: "stockSizes", icon: "📐", href: route.stockSizes, permission: "sizes-stock" },
  { key: "stockPieces", icon: "📏", href: route.stockPieces, permission: "pieces-stock" },
  { key: "processItemsStock", icon: "🧾", href: route.stockProcessItems, permission: "process-items-stock" },
  { key: "processPartyStock", icon: "🤝", href: route.stockProcessParties, permission: "process-party-stock" },
];

export const masterModules: DashboardModule[] = [
  { key: "parties", icon: "\uD83D\uDC65", href: route.parties, permission: "parties.menu" },
  { key: "items", icon: "\uD83D\uDCE6", href: route.items, permission: "items.menu" },
  { key: "processes", icon: "\u2699\uFE0F", href: route.processes, permission: "processes.menu" },
  { key: "processDefinitions", icon: "\uD83E\uDDED", href: route.processDefinitions, permission: "process-definitions.menu" },
  { key: "materials", icon: "\uD83D\uDCCF", href: route.materials, permission: "materials.menu" },
  { key: "itemSizes", icon: "\uD83D\uDCD0", href: route.itemSizes, permission: "item-sizes.menu" },
  { key: "users", icon: "\uD83D\uDC64", href: route.users, permission: "users.menu" },
];
